<template>
  <div :class="classes">
    <v-menu
      v-model="menu"
      :class="[$style.menu]"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      :min-width="min_width"
    >
      <template v-slot:activator="{ on, attrs }">
        <TextField
          v-model="text_date"
          v-mask="date_mask"
          :label="label"
          prepend-inner-icon="mdi-calendar"
          v-bind="attrs"
          blue_icon
          :dense="dense"
          :hide-details="hide_details"
          :error-messages="error_message"
          :rules="rules"
          :clearable="clearable"
          :require="required"
          @keyup="handle_key_up"
          @blur="text_date_changed"
          @click:clear="clear"
          @input="menu = false"
          @click:prepend-inner="menu = true"
          @click="menu = true"
          :small_error="small_info"
          :disabled="disabled"
          v-on="on"
          @keydown.prevent
        />
      </template>
      <v-date-picker
        v-bind="$attrs"
        v-on="$listeners"
        v-model="date_model"
        :max="max"
        first-day-of-week="1"
        color="accent"
        @input="menu = false"
        :disabled="disabled"
      />
    </v-menu>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import TextField from '../inputs/text-field/TextField.vue';

@Component({
  components: {
    TextField,
  },
})
export default class Datepicker extends Vue {
  mounted() {
    if (this.date_prop) {
      this.on_prop_date_change();
    }
  }

  @Prop({ type: Boolean, default: undefined })
  disabled!: boolean | undefined;

  @Prop({ type: String, default: '' })
  type_date!: string;

  @Prop({ type: String, default: 'Дата' })
  label!: string;

  @Prop({ type: String, default: '' })
  date_prop!: string;

  @Prop({ type: Boolean, default: false })
  small_calendar!: boolean;

  @Prop({ type: String, default: '' })
  error!: string;

  @Prop({
    type: [
      String, Array,
    ],
    default: '',
  })
  classes!: string | [];

  @Prop({ type: Boolean, default: false })
  hide_details!: boolean;

  @Prop({ type: Boolean, default: false })
  clearable!: boolean;

  @Prop({ type: Boolean, default: false })
  required!: boolean;

  @Prop({ type: Boolean, default: false })
  dense!: boolean;

  @Prop({ type: Array, default: () => [] })
  rules!: [];

  @Prop({ type: String, default: '' })
  max!: '';

  @Prop({ type: Boolean, default: false })
  small_info!: boolean;

  @Watch('date_prop')
  on_prop_date_change() {
    this.date = this.parse_date(this.date_prop);
    this.text_date = this.format_date(this.date_prop);
  }

  menu = false;

  date = '';

  text_date = '';

  error_message = '';

  get date_model() {
    return this.date ? this.date : '';
  }

  set date_model(date: string) {
    this.date = date;
    this.text_date = this.format_date(date);

    // на бэк отправляем в формате yyyy-mm-dd
    this.$emit('date_changed', this.date);
  }

  get date_mask() {
    return this.type_date === 'month' ? '##.####' : '##.##.####';
  }

  get min_width() {
    return this.small_calendar ? '' : '290px';
  }

  format_date(date: string) {
    if (!date) {
      return '';
    }

    if (date.split('.').length > 2) {
      return date;
    }

    const [
      year = '1970', month = '01', day = '01',
    ] = date.split('-');

    return `${day}.${month}.${year}`;
  }

  parse_date(date: string) {
    if (!date) {
      return '';
    }

    return date.split('.').reverse().join('-');
  }

  handle_key_up(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.text_date_changed();
    }
  }

  text_date_changed() {
    this.error_message = '';

    if (!this.text_date) {
      if (this.date_model) this.date_model = '';
      return;
    }

    const date_arr = this.text_date.split('.');

    if (!date_arr.length || date_arr.length <= 2) {
      this.error_message = 'Невалидная дата';
      this.emit_error();
      return;
    }

    const day = Number(date_arr[0]) || '';
    const month = Number(date_arr[1]) || '';
    const year = Number(date_arr[2]) || '';

    if (!day || !month || !year) {
      this.error_message = 'Невалидная дата';
      this.emit_error();
      return;
    }

    if (month < 1 || month > 12) {
      this.error_message = 'Невалидная дата';
      this.emit_error();
      return;
    }
    if (year < 1900) {
      this.error_message = 'Невалидная дата';
      this.emit_error();
      return;
    }

    if ((day && (day < 0 || day > 31)) || month > 12) {
      this.error_message = 'Невалидная дата';
      this.emit_error();
      return;
    }

    if (this.max && new Date(this.parse_date(this.text_date)) > new Date(this.max)) {
      this.error_message = 'Установленная дата превышает максимально возможную';
      this.emit_error();
      return;
    }

    this.$emit('date_changed', this.parse_date(this.text_date));
  }

  emit_error() {
    this.$emit('update:error', this.parse_date(this.text_date));
  }

  clear() {
    this.date_model = '';
    this.text_date = '';
  }
}
</script>

<style module lang="scss">
.menu {
  z-index: 1000 !important;
}
</style>
